export enum DefaultIncorporationTaskGroups {
  COMPANY_FORMATION_DETAILS = 'COMPANY_FORMATION_DETAILS',
}

export enum DefaultIncorporationTasks {
  FILL_CORPORATION_DETAILS = 'FILL_CORPORATION_DETAILS',
  REVIEW_CORPORATION_DETAILS = 'REVIEW_CORPORATION_DETAILS',
}
